// extracted by mini-css-extract-plugin
export default {"grid":"channelListSkeleton_grid__fAgkj","row":"channelListSkeleton_row__SuXfg","checkbox":"channelListSkeleton_checkbox__c2JcW","label":"channelListSkeleton_label__9MJ+s"};